import { Form } from 'antd';
import type { FormInstance } from 'antd/es/form';
import type { AssetDetailFormValues } from '~/app/hooks/asset/useAssetDetail';
import type { SiteLookup } from '~/app/services/site/site.service';

type SiteForMap = Pick<
  SiteLookup,
  'name' | 'address' | 'latitude' | 'longitude'
> | null;

function parseCoordinate(
  watched: string | undefined,
  fallback: number | null | undefined,
): number | null {
  const parsedValue = Number(watched);

  if (watched?.trim() && !Number.isNaN(parsedValue)) {
    return parsedValue;
  }

  return fallback ?? null;
}

export function useAssetDetailOverviewMapCoords(
  form: FormInstance<AssetDetailFormValues>,
  siteForMap: SiteForMap,
) {
  const watchedSiteLatitude = Form.useWatch('siteLatitude', form);
  const watchedSiteLongitude = Form.useWatch('siteLongitude', form);

  return {
    mapLatitude: parseCoordinate(
      watchedSiteLatitude,
      siteForMap?.latitude ?? null,
    ),
    mapLongitude: parseCoordinate(
      watchedSiteLongitude,
      siteForMap?.longitude ?? null,
    ),
  };
}
